import { FC } from 'react';
import { SortableHeader } from '../../components/SortableHeader';
import { IGetReleaseNotesTableItem } from '../../api/api';

interface ReleaseNotesTableProps {
  releaseNotesItems: IGetReleaseNotesTableItem[];
  sortConfig: { key: keyof IGetReleaseNotesTableItem; direction: 'asc' | 'desc' | null } | null;
  onSort: (key: keyof IGetReleaseNotesTableItem) => void;
  onRowClick: (id: string) => void;
}

const formatLocalDate = (publicationAt: string) => {
  const date = new Date(publicationAt);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const formatLocalTime = (publicationAt: string) => {
  const date = new Date(publicationAt);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
};

export const ReleaseNotesTable: FC<ReleaseNotesTableProps> = ({ releaseNotesItems, sortConfig, onSort, onRowClick }) => {
  return (
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <SortableHeader<IGetReleaseNotesTableItem>
              label="Title"
              sortKey="title"
              currentSort={sortConfig}
              onSort={onSort}
            />
            <SortableHeader<IGetReleaseNotesTableItem>
              label="Date"
              sortKey="publication_at"
              currentSort={sortConfig}
              onSort={onSort}
            />
            <SortableHeader<IGetReleaseNotesTableItem>
              label="Time"
              sortKey="publication_at"
              currentSort={sortConfig}
              onSort={onSort}
            />
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {releaseNotesItems.map((releaseNote) => (
            <tr
              key={releaseNote.id}
              onClick={() => onRowClick(releaseNote.id)}
              className="cursor-pointer hover:bg-gray-50"
            >
              <td className="px-6 py-4 whitespace-nowrap">{releaseNote.title}</td>
              <td className="px-6 py-4 whitespace-nowrap">{formatLocalDate(releaseNote.publication_at)}</td>
              <td className="px-6 py-4 whitespace-nowrap">{formatLocalTime(releaseNote.publication_at)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
